<template>
  <div>
    <div>重要訊息</div>
    <div>總評分:{{OperationSummary}}</div>
    <div>各店重要訊息</div>
    <paged-msg-table ref="msgComp" />
  </div>
</template>

<script>

import PagedMsgTable from './PagedMsgTable'

export default {
  name: 'MerchantAdminInfo',
  components: {
    PagedMsgTable
  },
  data: function () {
    return {
      
    }
  },
  props: [
    ],
  methods: {
    loadMsg: function () {
      alert('load msg')
    },
    cancel: function () {
      this.CancelCallback();
    }
  },
  computed: {
    OperationSummary: function () {
      let score = "0.0"
      if (this.$bus.session && this.$bus.session.operation_summary) {
        score = this.$bus.session.operation_summary.store_avg_score
      }
      return score
    }
  },
  activated () {
    // 動態組件預設全都cache,但最新訊息切換應抓新的
    // 所以要呼叫child來reload資料
    //this.$refs.msgComp.reload()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
